import React, { useState } from "react";
import CrudPage from "@/components/CrudPage";
import Sites from "@/pages/Sites";
import { UsersThree, MapPin } from "@phosphor-icons/react";

const TABS = [
  { key: "customers", label: "Customers", icon: UsersThree },
  { key: "sites", label: "Sites", icon: MapPin },
];

function CustomersList() {
  return (
    <CrudPage
      title="Customers"
      subtitle="Clients and their projects"
      endpoint="/customers"
      columns={[
        { key: "name", label: "Name", render: (v) => <span className="font-semibold">{v}</span> },
        { key: "contact_name", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "tags", label: "Tags", render: (v) => (
          <div className="flex flex-wrap gap-1" data-testid="customer-tags">
            {(v || []).map((t, i) => (
              <span key={i} data-testid="customer-tag-pill"
                className="inline-flex items-center bg-accent-tint text-ink-primary border border-accent-edge/40 text-[11px] font-semibold px-2 py-0.5 rounded-full">
                {t}
              </span>
            ))}
          </div>
        ) },
      ]}
      fields={[
        { key: "name", label: "Customer Name", required: true, full: true },
        { key: "contact_name", label: "Contact Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "tags", label: "Tags", type: "tags", full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}

export default function Customers() {
  const [tab, setTab] = useState("customers");
  return (
    <div className="h-full flex flex-col bg-surface-page" data-testid="customers-page">
      <div className="flex items-center gap-1 bg-surface-page px-4 pt-3 shrink-0">
        <div className="flex items-center bg-surface-inset rounded-[999px] p-0.5">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`customers-tab-${t.key}`}
              className={`px-3.5 h-8 rounded-[999px] text-[12px] font-bold uppercase tracking-[0.04em] inline-flex items-center gap-1.5 ${
                tab === t.key ? "bg-equipr-yellow text-black" : "text-ink-secondary hover:text-ink-primary"
              }`}>
              <t.icon size={14} weight="bold" /> {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        {tab === "customers" ? <CustomersList /> : <Sites />}
      </div>
    </div>
  );
}
